import { render, staticRenderFns } from "./mySpotCheck.vue?vue&type=template&id=dd969c4a&scoped=true"
import script from "./mySpotCheck.vue?vue&type=script&lang=js"
export * from "./mySpotCheck.vue?vue&type=script&lang=js"
import style0 from "./mySpotCheck.vue?vue&type=style&index=0&id=dd969c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd969c4a",
  null
  
)

export default component.exports